import {useEffect} from "react"

function MicroFrontend({host, microFrontendUiName}) {
    const normalizedHost = host?.startsWith('http') ? host : `https://${host}`;
    
    useEffect(() => {
        const scriptId = `micro-frontend-script-${microFrontendUiName}`;
        const renderMicroFrontend = () => {
            const renderFunctionName = `render${microFrontendUiName}`;
            const renderFunction = window[renderFunctionName];
            if (!renderFunction) {
                console.warn("Render function not found: ", renderFunctionName, window);
            }
            renderFunction(`${microFrontendUiName}-container`);
        };

        if (document.getElementById(scriptId)) {
            renderMicroFrontend();
            return;
        }

        fetch(`${normalizedHost}/asset-manifest.json`)
            .then((res) => res.json())
            .then((manifest) => {
                const script = document.createElement("script");
                script.id = scriptId;
                script.crossOrigin = "";
                script.src = `${normalizedHost}${manifest.files["main.js"]}`;
                script.onload = () => {
                    renderMicroFrontend();
                };
                script.onerror = (error) => {
                    console.error(`Failed to load microfrontend script from ${normalizedHost}:`, error);
                };
                document.head.appendChild(script);

                const style = document.createElement("link");
                style.href = `${normalizedHost}${manifest.files["main.css"]}`;
                style.rel = "stylesheet";
                document.head.appendChild(style);
            })
            .catch((error) => {
                console.error(`Failed to fetch asset-manifest from ${normalizedHost}/asset-manifest.json:`, error);
            });
    }, [normalizedHost, microFrontendUiName]);

    useEffect(() => {
        return () => {
            window[`unmount${microFrontendUiName}`] && window[`unmount${microFrontendUiName}`](`${microFrontendUiName}-container`);
        };
    }, [])

    return <main id={`${microFrontendUiName}-container`} />
}

export default MicroFrontend;